import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api, { API } from "@/lib/api";
import SiteRenderer from "@/components/SiteRenderer";

export default function BuildPreview() {
  const { bid } = useParams();
  const [site, setSite] = useState(null);

  useEffect(() => {
    api.get(`/build/businesses/${bid}`).then(({ data }) => {
      const w = data.website || {};
      setSite({ name: data.name, brand: data.brand, style: w.style, content: w.content,
        logo_asset_id: w.logo_asset_id, hero_image_asset_id: w.hero_image_asset_id,
        booking_links: w.booking_links, payment_links: w.payment_links, seo: w.seo, legal: w.legal });
    });
  }, [bid]);

  if (!site) return null;
  const assetUrl = (id) => `${API}/build/assets/${id}/file`;
  const onLead = async () => { alert("This is a preview. Lead capture works on the published site."); return false; };
  return <SiteRenderer site={site} assetUrl={assetUrl} onLead={onLead} preview />;
}
